import { ContentVideo } from '../model/extras.domain';

export const getPoster = (content: ContentVideo['value']): string => {
  if (content.thumbnailCustomURL) return content.thumbnailCustomURL;
  return `https://image.mux.com/${
    content.muxPlaybackId
  }/thumbnail.webp?smart_crop=true&time=${content.thumbnailTimestampMs / 1000}`;
};

export const getVideoThumbnail = (content: ContentVideo['value']): string => {
  if (content.coverURL) return content.coverURL;
  return getPoster(content);
};
